// Одна подпись на охраняемую территорию, прибитая к месту. Парк в векторных
// тайлах разрезан по тайлам, и подпись из тайлов дублировалась бы на каждом
// куске. Тайл несёт label_lon/label_lat - точку внутри всего парка (считает
// boundaries_tile), по ней подпись стоит на одном месте при любом сдвиге
// карты. Если тайл их не принёс (старая функция тайлов), точка берётся из
// охватывающего прямоугольника видимых кусков - такая подпись «ездит» за
// видимой частью парка, но хотя бы одна.

type Position = [number, number];
interface TileFeature {
  geometry: { type: string; coordinates: unknown };
  properties?: Record<string, unknown> | null;
}
export type Bounds = [number, number, number, number]; // west, south, east, north

const eachPoint = (coords: unknown, visit: (p: Position) => void): void => {
  if (!Array.isArray(coords)) return;
  if (typeof coords[0] === "number") visit(coords as Position);
  else for (const c of coords) eachPoint(c, visit);
};

const isNum = (v: unknown): v is number => typeof v === "number" && Number.isFinite(v);

export const protectedAreaLabelPoints = (features: TileFeature[], view: Bounds) => {
  const [west, south, east, north] = view;
  const parks = new Map<
    string,
    { props: Record<string, unknown>; anchor: Position | null; minX: number; minY: number; maxX: number; maxY: number }
  >();
  for (const f of features) {
    const props = f.properties ?? {};
    const name = String(props.name_ru ?? props.name ?? props.name_en ?? "");
    if (!name) continue;
    let park = parks.get(name);
    if (!park) {
      park = { props, anchor: null, minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity };
      parks.set(name, park);
    }
    if (isNum(props.label_lon) && isNum(props.label_lat)) park.anchor = [props.label_lon, props.label_lat];
    eachPoint(f.geometry.coordinates, ([x, y]) => {
      park!.minX = Math.min(park!.minX, x);
      park!.maxX = Math.max(park!.maxX, x);
      park!.minY = Math.min(park!.minY, y);
      park!.maxY = Math.max(park!.maxY, y);
    });
  }
  const out = [];
  for (const { props, anchor, minX, minY, maxX, maxY } of parks.values()) {
    let point: Position;
    if (anchor) {
      // Закреплённая точка вне экрана - подписи нет.
      if (anchor[0] < west || anchor[0] > east || anchor[1] < south || anchor[1] > north) continue;
      point = anchor;
    } else {
      const x0 = Math.max(minX, west);
      const x1 = Math.min(maxX, east);
      const y0 = Math.max(minY, south);
      const y1 = Math.min(maxY, north);
      if (x0 >= x1 || y0 >= y1) continue;
      point = [(x0 + x1) / 2, (y0 + y1) / 2];
    }
    out.push({ type: "Feature" as const, properties: props, geometry: { type: "Point" as const, coordinates: point } });
  }
  return { type: "FeatureCollection" as const, features: out };
};
